<h5 class="text-brut ml-3">Commenter la publication</h5>
<div id="reply-box">
    <div *ngFor="let comment of comments" 
        [ngClass]="{'comment-container': true, 'creator-comment-container': isCommentCreator(comment)}" >
        
        <div class="ml-4" id="my-profile-picture">
            <img [src]="comment?.profilePhotoUrl" alt="" class="profile-picture">
        </div>
        <div class="comment">
            <div [id]="'comment-' + comment.id">
                <div class="comment-name">{{comment?.creatorName}}</div>
                
                <div class="comment-comment" [innerHTML]="comment?.comment | formatText"></div>

                <img *ngIf="comment?.imageUrl" [src]="comment.imageUrl" alt="Comment image" class="comment-image">
                <audio *ngIf="comment?.audioUrl" controls class="audio-player">
                    <source [src]="comment.audioUrl" type="audio/mpeg">
                    Votre navigateur ne supporte pas l'élément audio.
                </audio>

                
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onEditComment(comment)">
                        <mat-icon>edit</mat-icon>
                        <span>Modifier</span>
                    </button>
                    <button mat-menu-item (click)="onDeleteComment(comment)">
                        <mat-icon>delete</mat-icon>
                        <span>Supprimer</span>
                    </button>
                </mat-menu>
            </div>
            <small style="color: gray; font-size: 0.8rem;">{{ getLastMessageFormattedDate(comment) }}</small>
        </div>
        <div *ngIf="isCommentCreator(comment)">
            <!-- Bouton option -->
            <button mat-icon-button [matMenuTriggerFor]="menu" class="option-button">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>
        
    </div>
</div>



<div id="reply-action-bar">
    <div class="recording-indicator" *ngIf="isRecording">
        <span>{{ enregistrement }}</span>
        <span id="timer">{{ recordingTime }}</span>
    </div>

    <button mat-button color="warn" id="uploadButton" [hidden]="isRecording">
        <label for="photo-upload">
            <input #photoSelector (change)="onFileSelected($event)" 
                   id="photo-upload" type="file" accept="image/*"/>
            <mat-icon>insert_photo</mat-icon>
        </label>
    </button>

    <div class="comment-input-container" [hidden]="isRecording">
        <textarea #commentInput class="textarea" placeholder="Commenter..." (input)="adjustTextareaHeight($event)" (keydown)="onKeydown($event)" rows="1" wrap="soft"></textarea>
    </div>

    <div #waveform class="waveform-container" *ngIf="isRecording"></div>

    <button mat-icon-button 
            (click)="isTextEntered ? onSendClick(commentInput) : toggleRecording()"
            [ngClass]="{'recording': isRecording}">
        <mat-icon>{{ isRecording ? 'stop' : (isTextEntered ? 'send' : 'mic') }}</mat-icon>
    </button>
</div>

<div class="preview-section" *ngIf="selectedImageUrl || audioBlobUrl">
    <div *ngIf="selectedImageUrl" class="image-preview-container">
        <img [src]="selectedImageUrl" alt="Preview" class="preview-image">
        <button (click)="clearSelectedImage()" class="clear-preview-btn" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div *ngIf="audioBlobUrl" class="audio-preview-container">
        <audio [src]="audioBlobUrl" controls class="audio-player"></audio>
        <button (click)="clearAudio()" class="clear-preview-btn" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
